import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import green from "@material-ui/core/colors/green";
import amber from "@material-ui/core/colors/amber";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";
import { withStyles } from "@material-ui/core/styles";
import * as SnackbarActions from "../store/SnackbarStore";

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

const SnackbarContentStyle = theme => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

function AdminSnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>
      ]}
      {...other}
    />
  );
}

AdminSnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["success", "warning", "error", "info"]).isRequired
};

const AdminSnackbarContentWrapper = withStyles(SnackbarContentStyle)(
  AdminSnackbarContent
);

const styles2 = theme => ({
  margin: {
    margin: theme.spacing.unit
  }
});

class AdminSnackbar extends React.Component {
  state = {
    open: false
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    const { dispatch, variant } = this.props;
    if (variant === "success") {
      dispatch(SnackbarActions.actionCreators.clearMessage());
    } else {
      dispatch(SnackbarActions.actionCreators.clearError());
    }
  };

  render() {
    const { classes, message, variant } = this.props;

    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
          open={true}
          //   autoHideDuration={6000}
          onClose={this.handleClose}
        >
          <AdminSnackbarContentWrapper
            variant={variant}
            className={classes.margin}
            message={message}
            onClose={this.handleClose}
          />
        </Snackbar>
      </div>
    );
  }
}

AdminSnackbar.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    error: state.snackbar.error || {}
  };
}

export default connect(mapStateToProps)(withStyles(styles2)(AdminSnackbar));
